var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZalo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_43618",
    "data-name": "Group 43618",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43609",
    "data-name": "Group 43609",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37288",
    "data-name": "Path 37288",
    d: "M3.993.115A11.668,11.668,0,0,1,6.069.022L6.01.077a7,7,0,0,0-2.2,2.342,11.44,11.44,0,0,0-1.4,6.227,11.027,11.027,0,0,0,1.4,5.019c.149.272.4.512.4.841a2.67,2.67,0,0,1-.8,1.88l.093.1c.444.484.917.938,1.368,1.416.641.723,1.371,1.363,2,2.1a15.606,15.606,0,0,1-3.133-.131,4.237,4.237,0,0,1-3-2.352,5.559,5.559,0,0,1-.459-2.232q0-5.271,0-10.541A4.79,4.79,0,0,1,1.433,1.469,4.226,4.226,0,0,1,3.993.115Z",
    transform: "translate(-0.279 -0.015)",
    fill: "#0068ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37289",
    "data-name": "Path 37289",
    d: "M204.422,101.347h.834q-.007,2.438,0,4.876c-.272-.038-.725.136-.827-.226C204.412,104.448,204.427,102.9,204.422,101.347Z",
    transform: "translate(-191.197 -94.794)",
    fill: "#0068ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37290",
    "data-name": "Path 37290",
    d: "M71.428,102.168c1.293,0,2.585-.01,3.877,0a1.172,1.172,0,0,1-.193.733c-.884,1.1-1.748,2.21-2.631,3.308.939.006,1.877,0,2.816,0-.017.219.06.475-.083.665-.089.123-.251.112-.385.113-1.174-.006-2.349.006-3.523-.006a1.065,1.065,0,0,1,.179-.719c.873-1.094,1.757-2.179,2.626-3.275-.893,0-1.787-.006-2.68,0C71.425,102.717,71.427,102.442,71.428,102.168Z",
    transform: "translate(-66.705 -95.557)",
    fill: "#0068ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43607",
    "data-name": "Group 43607",
    transform: "translate(14.608 7.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37291",
    "data-name": "Path 37291",
    d: "M227.315,118.289a1.915,1.915,0,1,1-1.305.991A1.912,1.912,0,0,1,227.315,118.289Zm-.016.824a1.131,1.131,0,0,0-.652,1.446,1.118,1.118,0,1,0,.652-1.446Z",
    transform: "translate(-225.796 -118.248)",
    fill: "#0068ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43608",
    "data-name": "Group 43608",
    transform: "translate(8.814 7.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37292",
    "data-name": "Path 37292",
    d: "M136.771,119.322a1.876,1.876,0,0,1,1.922-.629,2.352,2.352,0,0,1,.634.292c0-.061-.006-.182-.008-.242l.783,0q0,1.824,0,3.648a3.282,3.282,0,0,1-.575-.021c-.132-.054-.173-.2-.225-.316a1.858,1.858,0,0,1-2.45-.248A1.9,1.9,0,0,1,136.771,119.322Zm1.055.163a1.108,1.108,0,1,0,1.422.623A1.116,1.116,0,0,0,137.825,119.484Z",
    transform: "translate(-136.349 -118.628)",
    fill: "#0068ff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_43611",
    "data-name": "Group 43611",
    transform: "translate(2.12 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43610",
    "data-name": "Group 43610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37293",
    "data-name": "Path 37293",
    d: "M36.617.126a1.827,1.827,0,0,1,.447-.059c2.59.01,5.181,0,7.771,0a14.828,14.828,0,0,1,2.076.067,4.388,4.388,0,0,1,2.576,1.11,4.639,4.639,0,0,1,1.378,3.286q0,5.142,0,10.285l-.036.082a8.216,8.216,0,0,1-3.462,2.18,13.749,13.749,0,0,1-5.459.647,11.373,11.373,0,0,1-5.248-1.651,5.249,5.249,0,0,1-2.548.455l-.093-.1a2.67,2.67,0,0,0,.8-1.88c0-.33-.252-.57-.4-.841a11.027,11.027,0,0,1-1.4-5.019,11.44,11.44,0,0,1,1.4-6.227A7,7,0,0,1,36.617.126ZM44.11,6.616c.006,1.55-.01,3.1.007,4.65.1.361.555.188.827.226q-.007-2.438,0-4.876Zm-8.5.058c0,.274,0,.549,0,.823.893-.01,1.787,0,2.68,0-.869,1.1-1.753,2.182-2.626,3.275a1.065,1.065,0,0,0-.179.719c1.174.012,2.348,0,3.523.006.134,0,.3.01.385-.113.143-.19.065-.446.083-.665-.939,0-1.877,0-2.816,0,.883-1.1,1.748-2.21,2.631-3.308a1.172,1.172,0,0,0,.193-.733C38.194,6.664,36.9,6.673,35.609,6.674Zm11.4,1.076A1.915,1.915,0,0,0,45.758,10.6,1.9,1.9,0,1,0,47.013,7.75Zm-6.891.677a1.9,1.9,0,0,0,.08,2.481,1.858,1.858,0,0,0,2.45.248c.052.118.093.262.225.316a3.281,3.281,0,0,0,.575.021q0-1.825,0-3.648l-.783,0c0,.061.006.182.008.242a2.352,2.352,0,0,0-.634-.292A1.876,1.876,0,0,0,40.122,8.427Z",
    transform: "translate(-33.006 -0.067)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_37294",
    "data-name": "Path 37294",
    d: "M148.916,130.749a1.107,1.107,0,0,1,1.422.623,1.105,1.105,0,1,1-1.422-.623Z",
    transform: "translate(-140.745 -122.226)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37295",
    "data-name": "Path 37295",
    d: "M238.551,130.547a1.122,1.122,0,1,1-.652,1.446A1.122,1.122,0,0,1,238.551,130.547Z",
    transform: "translate(-224.559 -122.04)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_43612",
    "data-name": "Group 43612",
    transform: "translate(3.228 14.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37296",
    "data-name": "Path 37296",
    d: "M66.833,228.663l.051-.056a5.787,5.787,0,0,1-.58,2.965,4.25,4.25,0,0,1-2.8,2.09,9.381,9.381,0,0,1-2.013.158H55.27c-.6-.01-1.193.018-1.787-.013-.628-.736-1.358-1.376-2-2.1-.451-.477-.924-.932-1.368-1.416a5.249,5.249,0,0,0,2.548-.455,11.373,11.373,0,0,0,5.248,1.651,13.749,13.749,0,0,0,5.459-.647A8.216,8.216,0,0,0,66.833,228.663Z",
    transform: "translate(-50.116 -228.607)",
    fill: "#005be0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZalo);
export default __webpack_public_path__ + "static/media/zalo.b29f9606eb05715e60b7603d5c7e7da1.svg";
export { ForwardRef as ReactComponent };